import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';

import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import styled from "styled-components";
import logo from '../logo.png';
import sdi from "../sdi.png";
import sj from "../logo_big.png";

import { getCookie } from '../Helpers';
import { useState, useEffect } from 'react';
import Config from '../config.json';

export default function Navbar({ auth, setOpen }) {
    const [anchorEl, setAnchorEl] = useState(null);


    const contributor = getCookie('CONTRIBUTOR');

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClickOpen = () => {
        setOpen(true);
        handleClose();
    };


    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <AppBarWhite position="static">
            <Toolbar>
                <Wrapper>
                    <LeftMenu>
                        <Logo>
                            <img src={logo} alt="logo geospasial untuk negeri" width="145px" />
                        </Logo>
                        <Logo>
                            <img src={sdi} alt="logo satu data indonesia" width="75px" />
                        </Logo>
                        <Logo>
                            <img  src={Config.logo} alt={Config.nama_sj} width="45px" />
                        </Logo>
                    </LeftMenu>
                    {
                        auth &&
                        <RightMenu>

                            <Welcome>
                                Hi, {contributor}
                            </Welcome>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="primary"
                            >
                                <AccountCircle fontSize="large" />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleClickOpen}>Profile</MenuItem>
                                <MenuItem onClick={handleClose} component="a" href="#/logout">Logout</MenuItem>
                            </Menu>
                        </RightMenu>
                    }
                </Wrapper>
            </Toolbar>
        </AppBarWhite>
    )
}
/*

                                <MenuItem onClick={handleClose}>My account</MenuItem>
  <Link>Unstyled, boring Link</Link>
                            <StyledLink>Styled, exciting Link</StyledLink>
const Link = ({ className, children }) => (
    <a className={className}>
        {children}
    </a>
);

const StyledLink = styled(Link)`
    color: palevioletred;
    font-weight: bold;
`;

const Input = styled.input`
  padding: 0.5em;
  margin: 0.5em;
  color: ${props => props.inputColor || "palevioletred"};
  background: papayawhip;
  border: none;
  border-radius: 3px;
`;
 <Input defaultValue="@geelen" type="text" inputColor="rebeccapurple" />
*/
const AppBarWhite = styled(AppBar)`
    background-color: #ffffff !important;
    border-bottom: solid 4px #009edb;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const LeftMenu = styled.div`
  display: flex;
  align-items: flex-start;
`;
const Logo = styled.div`
  display: flex;
  margin-right: 20px;
`;

const WrapTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-size: 24px;
  font-weight: 600;
  margin: 0px;
`;

const Date = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;
`;

const Welcome = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin: 0px;
  padding-right: 5px;
`;
